import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Button
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from 'axios';
import moment from "moment";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// API YAPILANDIRMASI
const API_BASE_URL = "https://tazelyapi.stechomeyazilim.info";
const ORDER_ENDPOINT = `${API_BASE_URL}/Complated_Order_Detail`; 
const IMAGE_BASE_URL = 'https://bittigittipreview.stechomeyazilim.info/';

const ContactsList = props => {
  const tableRef = useRef(null);
  document.title = "Siparişler | Tazelya ADMIN PANELI";

  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [currentOrderItems, setCurrentOrderItems] = useState([]);

  const fetchOrders = async () => {
    try {
      setIsLoading(true);
      // GÜNCELLEME: Delivery_Time_Text bilgisini $select içerisine ekledik
      const query = `${ORDER_ENDPOINT}?` + 
        `$expand=Complated_Order($select=ID,TotalPrice,Created_DateTime,Order_Status_ID,Delivery_Time_Text;$expand=Users($select=ID,Users_Name),Order_Status($select=ID,Order_Status_Title)),` +
        `Products($select=ID,Products_Name,ImageCover)` +
        `&$orderby=ID desc`;
      
      const response = await axios.get(query, { timeout: 15000 });
      setOrders(response.data.value || []);
      setIsLoading(false);
    } catch (error) {
      console.error("Siparişler çekilemedi:", error);
      toastr.error("Bağlantı hatası: Veriler yüklenemedi.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const tableData = useMemo(() => {
    const grouped = {};
    orders.forEach(item => {
      const oid = item.Complated_Order_ID;
      if (!grouped[oid]) {
        grouped[oid] = {
          ID: oid,
          data: item, 
          details: [],
          totalQty: 0
        };
      }
      grouped[oid].details.push(item);
      grouped[oid].totalQty += item.Quantity;
    });
    return Object.values(grouped);
  }, [orders]);

  const updateStatus = async (orderId, statusId, toastMsg) => {
    try {
      await axios.patch(`${API_BASE_URL}/Complated_Order(${orderId})`, {
        Order_Status_ID: statusId
      });
      toastr.success(toastMsg);
      fetchOrders(); 
    } catch (error) {
      toastr.error("Hata oluştu!");
    }
  };

  const columns = useMemo(() => [
    {
      Header: "No",
      accessor: "ID",
      Cell: cellProps => <span className="fw-bold">#{cellProps.value}</span>,
    },
    {
      Header: "Müşteri",
      accessor: "data.Complated_Order.Users.Users_Name",
      Cell: cellProps => <span>{cellProps.value || "Bilinmiyor"}</span>,
    },
    {
      Header: "Sipariş Tarihi",
      accessor: "data.Complated_Order.Created_DateTime",
      Cell: cellProps => <span>{moment(cellProps.value).format("DD.MM.YYYY HH:mm")}</span>,
    },
    {
      Header: "Teslimat Zamanı", // YENİ KOLON
      accessor: "data.Complated_Order.Delivery_Time_Text",
      Cell: cellProps => (
        <div className="d-flex align-items-center">
            <i className="mdi mdi-clock-outline me-1 text-primary"></i>
            <span className="text-primary fw-medium">{cellProps.value || "Hemen"}</span>
        </div>
      ),
    },
    {
      Header: "Tutar",
      accessor: "data.Complated_Order.TotalPrice",
      Cell: cellProps => <span className="text-success fw-bold">{cellProps.value} TL</span>,
    },
    {
      Header: "Durum",
      accessor: "data.Complated_Order.Order_Status.Order_Status_Title",
      Cell: cellProps => {
        const statusID = cellProps.row.original.data.Complated_Order.Order_Status_ID;
        let color = "warning";
        if (statusID === 3) color = "success"; 
        if (statusID === 6) color = "danger";  
        if (statusID === 7) color = "info";    
        return <Badge color={color} pill>{cellProps.value}</Badge>;
      },
    },
    {
      Header: "İşlemler",
      Cell: cellProps => {
        const row = cellProps.row.original;
        const statusID = row.data.Complated_Order.Order_Status_ID;
        return (
          <div className="d-flex gap-2">
            <Button size="sm" color="soft-primary" onClick={() => { setCurrentOrderItems(row.details); setModalDetail(true); }}>
              <i className="mdi mdi-eye font-size-15" />
            </Button>
            {statusID === 1 && (
              <Button size="sm" color="soft-success" onClick={() => updateStatus(row.ID, 7, "Sipariş Onaylandı")}>
                <i className="mdi mdi-check font-size-15" />
              </Button>
            )}
            {statusID === 7 && (
              <Button size="sm" color="success" onClick={() => updateStatus(row.ID, 3, "Sipariş Teslim Edildi")}>
                <i className="mdi mdi-bike-fast font-size-15" />
              </Button>
            )}
          </div>
        );
      },
    },
  ], [orders]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="E-Ticaret" breadcrumbItem="Siparişler" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoading ? (
                    <div className="text-center my-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                      </div>
                      <p className="mt-2">Siparişler yükleniyor...</p>
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={tableData}
                      isGlobalFilter={true}
                      customPageSize={20}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modalDetail} toggle={() => setModalDetail(!modalDetail)} size="lg" centered>
        <ModalHeader toggle={() => setModalDetail(!modalDetail)}>Sipariş Detayı</ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Ürün</th>
                  <th>Adet</th>
                  <th>Birim Fiyat</th>
                  <th>Toplam</th>
                </tr>
              </thead>
              <tbody>
                {currentOrderItems.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                        <img 
                          src={`${IMAGE_BASE_URL}${item.Products?.ImageCover}`} 
                          alt="" className="avatar-xs rounded-circle me-2" 
                        />
                        {item.Products?.Products_Name}
                    </td>
                    <td>{item.Quantity}</td>
                    <td>{item.Products?.DiscountedPrice || item.Products?.Price} TL</td>
                    <td>{item.TotalPrice} TL</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);